// UserDetails/Shops/ShopList.jsx

export default function ShopList({ shops, activeShop, onSelect }) {
  return (
    <div className="space-y-1 p-2">
      {shops.map((shop) => (
        <div
          key={shop._id}
          className={`p-3 rounded-md cursor-pointer flex flex-col border-l-4 transition-colors
            ${
              activeShop?._id === shop._id
                ? "border-blue-600 bg-gray-100"
                : "border-transparent hover:bg-gray-50"
            }
          `}
          onClick={() => onSelect(shop)}
        >
          <div className="font-semibold text-sm text-gray-800">{shop.name}</div>
          <div className="text-xs text-gray-500">
            {shop.city}, {shop.state}
          </div>
          <span
            className={`mt-2 px-2 py-0.5 rounded-full text-xs font-medium w-fit capitalize
            ${
              shop.status === "APPROVED"
                ? "bg-green-100 text-green-800"
                : shop.status === "REJECTED"
                ? "bg-red-100 text-red-800"
                : shop.status === "HOLD"
                ? "bg-yellow-100 text-yellow-800"
                : "bg-gray-200 text-gray-700"
            }`}
          >
            {shop.status.toLowerCase()}
          </span>
        </div>
      ))}
    </div>
  );
}
